import React from 'react';
import { Box } from '@chakra-ui/react';

const Wave = ({ fill = 'white', flip = false, height = 60, position = 'bottom' }) => (
  <Box
    position="absolute"
    top={position === 'top' ? 0 : undefined}
    bottom={position === 'bottom' ? 0 : undefined}
    left={0}
    right={0}
    h={`${height}px`}
    transform={flip ? 'scaleY(-1)' : undefined}
    pointerEvents="none"
    zIndex={2}
  >
    <Box
      as="svg"
      viewBox="0 0 1440 80"
      preserveAspectRatio="none"
      w="100%"
      h="100%"
      display="block"
    >
      <path
        d="M0,48 C220,88 420,8 700,26 C960,44 1200,86 1440,38 L1440,80 L0,80 Z"
        fill={fill}
      />
    </Box>
  </Box>
);

export default Wave;
